import { createGlobalStyle } from 'styled-components';

export const GlobalListsStyled = createGlobalStyle`
    ul, ol {
        margin: 0;
        padding-left: 1.25rem;
    }

    ul {
        list-style: disc;
    }

    ol {
        list-style: decimal;
    }

    li {
        margin: 0 0 var(--space-1);
        color: var(--color-white-95);
    }

    li::marker {
        color: var(--text-color-secondary);
    }

    dl {
        margin: 0;
    }

    dt {
        font-size: var(--font-size-sm);
        color: var(--text-color-secondary);
    }

    dd {
        margin: 0;
        font-size: var(--font-size-md);
        font-weight: 500;
        color: var(--color-white-95);
    }

    .list-unstyled {
        padding-left: 0;
        list-style: none;
    }
`;
